<!-- eslint-disable vue/no-unused-vars -->
<template>
  <v-container>
    <v-card v-if="projeto">
      <v-card-item>
        <v-card-title> {{ projeto.nome }}</v-card-title>
        <v-card-subtitle>Sigla: {{ projeto.sigla }}</v-card-subtitle>
      </v-card-item>

      <v-container class="w-50">
        <v-row class="mb-4" justify="center">
          <router-link
            class="mx-2"
            :to="'/projects/' + this.idProjeto + '/Charters/'"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="130px"
              >
                <v-icon
                  class="mt-3"
                  size="x-large"
                  icon="mdi-clipboard-outline"
                />
                <v-card-text class="pt-0"> Charters </v-card-text>
              </v-card>
            </v-hover>
          </router-link>

          <router-link
            class="mx-2"
            :to="'/projects/' + this.idProjeto + '/bugs/'"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="130px"
              >
                <v-icon class="mt-3" size="x-large" icon="mdi-bee" />
                <v-card-text class="pt-0">Bugs</v-card-text>
              </v-card>
            </v-hover>
          </router-link>
        </v-row>
        <v-row class="mb-4" justify="center">
          <router-link
            class="mx-2"
            :to="'/projects/' + this.idProjeto + '/validation-scope'"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="130px"
              >
                <v-icon
                  class="mt-3"
                  size="x-large"
                  icon="mdi-application-brackets"
                />
                <v-card-text class="pt-0">Escopo de validação</v-card-text>
              </v-card>
            </v-hover>
          </router-link>

          <router-link
            class="mx-2"
            :to="'/projects/' + this.idProjeto + '/roteiros/'"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="130px"
              >
                <v-icon class="mt-3" size="x-large" icon="mdi-script" />
                <v-card-text class="pt-0">Roteiros</v-card-text>
              </v-card>
            </v-hover>
          </router-link>
        </v-row>
        <v-row class="mb-4" justify="center">
          <router-link
            class="mx-2"
            :to="'/projects/' + this.idProjeto + '/test-users/'"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="130px"
              >
                <v-icon class="mt-3" size="x-large" icon="mdi-email-multiple" />
                <v-card-text class="pt-0">Convites de Usuários</v-card-text>
              </v-card>
            </v-hover>
          </router-link>

          <router-link
            class="mx-2"
            :to="'/projects/' + this.idProjeto + '/resultados-roteiros/'"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="130px"
              >
                <v-icon class="mt-3" size="x-large" icon="mdi-chart-bar" />
                <v-card-text class="pt-0">Resultados</v-card-text>
              </v-card>
            </v-hover>
          </router-link>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
/**
 * @module ProjectValidationDashboard
 * @desc Página que mostra opções relacionadas a validação de um projeto.
 * @vue-data {Object} [projeto={}] Objeto com informações de um projeto.
 * @vue-data {String} [idPprojeto=''] String que guarda o id do projeto.
 */
import axios from 'axios';

import store from '@/store/store';
export default {
  data() {
    return { projeto: {}, idProjeto: '' };
  },
  mounted() {
    this.objetoFormaAtuacao = JSON.parse(
      localStorage.getItem('formaAtuacaoProjeto'),
    );
    this.objetoFormaAtuacao.forEach((element) => {
      if (element.id_projeto.some((idProjeto) => idProjeto == this.idProjeto)) {
        this.atuacao = element.forma_atuacao;
      }
    });
    localStorage.setItem('formaAtuacao', JSON.stringify(this.atuacao));
  },
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.getProjectInfo();
  },
  methods: {
    /**
     * Realiza uma requisição HTTP para obter informações sobre o projeto.
     */
    getProjectInfo() {
      const API_URL = process.env.VUE_APP_API_URL;
      axios
        .get(API_URL + '/projetos/listaprojeto/' + this.idProjeto, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.projeto = res.data;
          localStorage.setItem('projeto', this.projeto.nome);
          console.log(res.data);
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
